export default class TwilioWorkerModel {
  public activity!: string;
  public name!: string;
  public sid!: string;
  public status!: boolean;
  public url!: string;
}
